/**
 * Precision Report Card Modals Component
 * Handles modal functionality for report cards
 * Note: migrateSection() should be called before this in the main init
 */

export function initPrecisionModals() {
  // Initialize modal functionality
  initModalTriggers();
  initModalClose();
}

/**
 * Open a modal by its ID
 * @param {string} modalId - The modal ID (data-modal-id attribute value)
 * @returns {boolean} - Returns true if modal was found and opened, false otherwise
 */
export function openModalById(modalId) {
  if (!modalId) {
    console.warn('openModalById: modalId is required');
    return false;
  }

  const modal = document.querySelector(`[data-modal-id="${modalId}"]`);
  if (!modal) {
    console.warn(`openModalById: Modal with ID "${modalId}" not found`);
    return false;
  }

  // Close any currently open modal first
  const openModal = document.querySelector('.precision-report-modal-overlay.is-open');
  if (openModal && openModal !== modal) {
    openModal.classList.remove('is-open');
  }

  // Open the requested modal
  modal.classList.add('is-open');
  document.body.style.overflow = 'hidden';
  
  return true;
}



function initModalTriggers() {
  window.openModalById = openModalById;
  const triggers = document.querySelectorAll('[data-modal-trigger]');
  triggers.forEach((trigger) => {
    // Skip if already initialized
    if (trigger.dataset._modalAttached) return;
    trigger.dataset._modalAttached = true;

    trigger.addEventListener('click', function() {
      const modalId = this.dataset.modalTrigger;
      const modal = document.querySelector(`[data-modal-id="${modalId}"]`);
      if (modal) {
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }
    });
  });
}

function initModalClose() {
  const closeButtons = document.querySelectorAll('[data-modal-close]');
  // Close button
 closeButtons.forEach((closeBtn) => {
    if (closeBtn.dataset._closeAttached) return;
    closeBtn.dataset._closeAttached = true;

    closeBtn.addEventListener('click', function() {
      const modal = this.closest('[data-modal-id]');
      if (modal) {
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
  });

  // Click outside
  document.querySelectorAll('.precision-report-modal-overlay').forEach((overlay) => {
    if (overlay.dataset._overlayAttached) return;
    overlay.dataset._overlayAttached = true;

    overlay.addEventListener('click', function(e) {
      if (e.target === this) {
        this.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
  });

  // Escape key (only attach once)
  if (!window._modalEscapeAttached) {
    window._modalEscapeAttached = true;
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        const openModal = document.querySelector('.precision-report-modal-overlay.is-open');
        if (openModal) {
          openModal.classList.remove('is-open');
          document.body.style.overflow = '';
        }
      }
    });
  }
}

export default initPrecisionModals;

